module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('div', {
    staticClass: "nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar_src,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t你好, " + _vm._s(_vm.user.nickname) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "rank"
  }, [_c('span', {
    staticStyle: {
      "background-color": "#fe5f01",
      "color": "white",
      "padding": "0 5px"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.user.rank) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "coins"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.user.coins) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "diamonds"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.user.diamonds) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "exit"
  }, [_c('span', {
    staticClass: "go-back",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home_logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-af19c828"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/component/HeaderComponent.vue
// module id = 213
// module chunks = 2